import Translator from 'bazinga-translator'
import { FreeRoundNotification } from 'components/UserNotifications/schemas/freeRoundNotificationSchema'
import { money } from 'utils/numbers'

import { UserNotificationHandler } from '../type'
import SimpleDialog from 'UI/SimpleDialog'

export class FreeRoundNotificationHandler implements UserNotificationHandler<FreeRoundNotification> {
  render(notification: FreeRoundNotification, confirm: () => void) {
    SimpleDialog.dialog({
      title: this.getTitle(),
      type: 'confirm',
      content: `<h4>${this.getBody(notification)}</h4>`,
      buttons: {
        accept: {
          label: Translator.trans('notifications.freeRound.accept'),
          callback: () => {
            confirm()
          },
        },
      },
    })
  }

  private getTitle() {
    return Translator.trans(`notifications.type.freeRound.header`)
  }

  private getBody(notification: FreeRoundNotification) {
    return Translator.trans(`notifications.type.freeRound.body`, {
      amount: money(notification.amount, false),
      game: notification.game,
    })
  }
}
